import React from 'react';

import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { MORTGAGE } from '../../../../lib/analytics-constants';
import { validationsSelector } from '../../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../../lib/selectors/mortgage-calculator';
import {
  MortgageInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
} from '../../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const PurchasePriceInput: React.FC<MortgageInput> = ({
  manualInputs,
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
  onBlur,
  // @ts-ignore - ignore error
  autoFocus,
}) => {
  const value = manualInputs?.purchasePrice;
  const placeholder = num.formatCurrency(inputs?.purchasePrice);
  const errorMessage = validations?.purchasePrice?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'purchasePrice',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'purchasePrice',
      additionalInputIdsToValidate: ['downPayment'],
      calculator: MORTGAGE,
      inputType: 'currency',
    });
  };

  return (
    <InputMoney
      label={label}
      placeholder={placeholder}
      value={value}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
      onBlur={onBlur}
      // @ts-ignore - ignore error
      autoFocus={autoFocus}
      decimalScale={0}
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(PurchasePriceInput);
